import { StylesBuilder } from './StylesBuilder'
import { HeaderBuilder } from './HeaderBuilder'
import { SectionBuilder } from './SectionBuilder'
import { ComponentBuilder } from './ComponentBuilder'
export class LayoutBuilder {
  constructor(layout) {
    this.layout = layout
    window.StylesBuilder = new StylesBuilder
  }

  build() {
    this.components = this.buildComponents()
    this.topSection = this.buildTopSection()
    this.bottomSection =  this.buildBottomSection()    
    this.header = this.buildHeader()
    this.styles = window.StylesBuilder.build()
    console.log({
      styles: this.styles,
      header: this.header,
      topSection: this.topSection,
      bottomSection: this.bottomSection,
      components: this.components,
    })
  }

  buildComponents() {
    return this.layout.components.map(component => new ComponentBuilder(component).build())
  }

  buildTopSection() {
    if (! this.hasTopSection()) {
      return ''
    }
    return new SectionBuilder(this.layout.topSection).build()
  }

  hasTopSection() {
    return !! this.layout.topSection
  }

  buildBottomSection() {
    if (! this.hasBottomSection()) {
      return ''      
    }
    return new SectionBuilder(this.layout.bottomSection).build()  
  }

  hasBottomSection() {
    return !! this.layout.bottomSection
  }

  buildHeader() {
    if (! this.hasHeader()) {
      return ''
    }
    return new HeaderBuilder(this.layout.header).build()
  }

  hasHeader() {
    return !! this.layout.header
  }
}